import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';
import { AuthConfiguration } from '@/configuration';
import { ClientInformation } from '@/types';

interface GetClientInformationsAgrs {
  clientId: string;
}

const getClientInformations = async ({
  clientId,
}: GetClientInformationsAgrs): Promise<
  BackResponse<ClientInformation> | BackResponseFailure
> => {
  try {
    const ENDPOINT = `${AuthConfiguration.authority}/api/client/information`;

    return await apiCall<BackResponse<ClientInformation>>(
      buildUrl(ENDPOINT, {
        clientId,
      }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getClientInformations;
